import classNames from "classnames";
// React
import React from "react";
// Transitions
import { RouteTransition } from "react-router-transition";
//import ReactRouterTransition from "react-router-transition";
import * as utils from "common/ui/containers/routeTransitionWrapper/utils";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ReactRouteTransition.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ReactRouteTransition extends React.Component {
    render() {
        //pathname={this.props.pathname}
        return (React.createElement(RouteTransition, Object.assign({ className: classNames(styles.transitionWrapper, this.props.isRelativeContainer && styles.relativeContainer) }, utils.animatePageTransition),
            React.createElement("div", { key: 0, className: styles.container }, this.props.children)));
    }
}
